export default class MassiaSelectController {
    static $inject = [
        '$scope',
        '$state',
        '$stateParams',
        'MassiaSelectService',
        'MassiaSelectSupervisorService',
        'notification',
        '$location',
        '$translate',
        'SharedDataService',
        '$attrs',
        '$timeout',
        'localStorageService'
    ];

    constructor(
        $scope,
        $state,
        $stateParams,
        MassiaSelectService,
        MassiaSelectSupervisorService,
        notification,
        $location,
        $translate,
        SharedDataService,
        $attrs,
        $timeout,
        localStorageService
    ) {
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.MassiaSelectService = MassiaSelectService;
        this.MassiaSelectSupervisorService = MassiaSelectSupervisorService;
        this.notification = notification;
        this.$location = $location;
        this.$translate = $translate;
        this.SharedDataService = SharedDataService;
        this.$attrs = $attrs;
        this.$timeout = $timeout;
        this.localStorageService = localStorageService;
        this.searchText = '';
        this.name = this.$attrs.name;
        this.filteredOptions = [];
        this.displayLimit = 20;
        this.messageError = '';
        this.error = false;
        this.datalinks = [];
        this.options = [];
        this.highlightedIndex = -1;
    }

    waitUntilDefined(getter) {
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                const val = getter();
                if (val !== undefined && val !== null) {
                    clearInterval(interval);
                    resolve(val);
                }
            }, 20);
        });
    }

    reinitSelect(objetName) {
        var dataObject = {
            value: '',
            libelle: '',
            messageType: '',
            message: ''
        };
        if (this.config.callbackOnChange != null) this.config.callbackOnChange(0);
        this.SharedDataService.setData(objetName, dataObject);
    }

    //--------------------------------------------------------------
    // PARSING DU NOUVEAU FORMAT PARAMS
    //--------------------------------------------------------------
    parseParams() {
        // Toujours initialiser
        this.params = [];
        this.paramKeys = [];
        this.paramConfigMap = {};

        if (!this.config || !this.config.params) {
            return;
        }

        let raw = this.config.params;

        try {
            // -----------------------------
            // 1) STRING → JSON.parse
            // -----------------------------
            if (typeof raw === 'string') {
                raw = JSON.parse(raw);
            }

            // -----------------------------
            // 2) Si ce n'est pas un array → stop
            // -----------------------------
            if (!Array.isArray(raw)) {
                console.error('[MassiaSelect] ❌ config.params doit être un array :', raw);
                return;
            }

            // -----------------------------
            // 3) Maintenant c'est OK → on assigne
            // -----------------------------
            this.params = raw;

            // Récupère les clés (ex: ["societe","site"])
            this.paramKeys = this.params.map((obj) => Object.keys(obj)[0]);

            // Remplit la map
            this.paramKeys.forEach((key, index) => {
                this.paramConfigMap[key] = this.params[index][key];
            });

            //console.log("[MassiaSelect] ✔ params OK :", this.paramConfigMap);
        } catch (e) {
            console.error('Erreur parsing params MassiaSelect :', e);
            this.params = [];
            this.paramKeys = [];
            this.paramConfigMap = {};
        }
    }

    //--------------------------------------------------------------
    // RÉCUPÉRATION DES VALEURS DE CHAQUE PARAM
    //--------------------------------------------------------------
    getParamValues() {
        const paramValues = {};

        if (!this.params || !Array.isArray(this.params)) {
            return paramValues;
        }

        this.params.forEach((paramObj) => {
            const argName = Object.keys(paramObj)[0];
            const config = paramObj[argName];

            if (!config || !config.datalink) return;

            // nom du champ dans SharedDataService
            const fieldName = config.datalink;

            // récupération valeur
            const fieldData = this.SharedDataService.getData(fieldName);

            if (fieldData && fieldData.value !== undefined) {
                paramValues[argName] = fieldData.value; // clé = nom de l'argument
            } else if (config.default !== undefined) {
                paramValues[argName] = config.default; // fallback
            } else if (!config.datalinkOptional) {
                // bloque le chargement si obligatoire
                paramValues[argName] = null;
            }
        });

        return paramValues;
    }

    //--------------------------------------------------------------
    // VALIDATION DES PARAMS (obligatoires ou optionnels)
    //--------------------------------------------------------------
    checkParamsAreValid(paramValuesObj) {
        // paramValuesObj doit être un objet :
        // ex: { provenance:"52098", societe:"6167" }
        if (!this.paramKeys || !this.paramConfigMap || !paramValuesObj) {
            console.log(
                '🚀 ~ MassiaSelectController ~ checkParamsAreValid ~ this.paramKeys:',
                this.name,
                this.ngModel,
                this.paramKeys,
                this.paramConfigMap,
                paramValuesObj
            );
            return true;
        }

        for (let i = 0; i < this.paramKeys.length; i++) {
            const key = this.paramKeys[i]; // ex "provenance"
            const cfg = this.paramConfigMap[key]; // config : { datalink:"...", datalinkOptional:true }

            // Valeur réelle venant du SharedDataService
            const rawVal = paramValuesObj[key]; // <-- CORRECT
            const realVal = rawVal !== undefined ? rawVal : '';

            const optional = cfg?.datalinkOptional === true;

            //------------------------------------------------------
            // 🔥 Test final : on bloque seulement si NON optional
            //------------------------------------------------------
            if (!optional && (realVal === '' || realVal === '0' || realVal === undefined)) {
                this.placeholder = 'En attente du champ ' + (cfg.label || key);
                this.options = [];
                this.filteredOptions = [];
                console.log('PARAM CHECK → FALSE ❌ (manque ' + key + ')', this.name);
                return false;
            }
        }

        console.log('PARAM CHECK → OK ✅', this.name);
        return true;
    }

    //--------------------------------------------------------------
    // WATCH GLOBAL SUR LES PARAMS
    //--------------------------------------------------------------
    watchParams() {
        this.$scope.$watchGroup(
            // 🔍 On observe chaque champ lié
            this.paramKeys.map((k) => {
                const cfg = this.paramConfigMap[k];
                const datalinkName = cfg.datalink;

                return () => {
                    const d = this.SharedDataService.getData(datalinkName);
                    return d ? d.value : '';
                };
            }),

            async (newVals, oldVals) => {
                //console.log("1 watchParams➜", this.name, newVals, oldVals, this.ngModel);
                // ➜ Pas de changement réel
                if (angular.equals(newVals, oldVals)) return;

                await this.checkParamsAndLoad();
            }
        );
    }

    async checkParamsAndLoad() {
        //Protection contre appel concurrent (ex: 2 params qui changent en même temps ou presque, autoselect par exemple)
        const callId = ++this._loadCallId;

        // ➜ Récupère l’objet : { societe: "55", provenance: "52098" }
        const paramValues = this.getParamValues();

        // 🔴 PARAMÈTRES NON VALIDES → ON RÉINITIALISE
        if (!this.checkParamsAreValid(paramValues)) {
            // console.log("2 watchParams➜checkParamsAreValid➜", this.name, paramValues, this.ngModel);
            // Même comportement que ton ancien reinitSelect()
            this.ngModel = '0';
            this.searchText = '';
            this.options = [];

            this.SharedDataService.setData(this.name, {
                value: '0',
                libelle: '',
                messageType: '',
                message: ''
            });

            return;
        }
        //console.log("3 watchParams➜",this.name,this.ngModel);

        var originalValue = this.ngModel;

        // 🟢 PARAMÈTRES VALIDES → CHARGEMENT DES OPTIONS
        await this.loadDataAccordingToDatatype(paramValues);

        //Nouvel appel effectué, on garde pas l'ancien résultat
        if (callId !== this._loadCallId) return;

        if (originalValue && originalValue !== '0') {
            // Cherche si elle existe dans les options chargées
            const stillExists = this.options.some((opt) => String(opt.id) === String(originalValue));

            if (stillExists) {
                // 4️⃣ Si oui → on restaure la sélection automatiquement
                this.ngModel = originalValue;
                const opt = this.options.find((o) => String(o.id) === String(originalValue));
                this.searchText = opt ? opt.value : '';

                this.SharedDataService.setData(this.name, {
                    value: String(originalValue),
                    libelle: this.searchText,
                    messageType: '',
                    message: ''
                });

                //console.log("✔ watchParams → restauration automatique :", this.name, originalValue);
            } else {
                // 5️⃣ Sinon → valeur supprimée → reset
                //console.log("⚠️ watchParams → valeur supprimée des options :", this.name, originalValue);

                this.ngModel = '0';
                this.searchText = '';

                this.SharedDataService.setData(this.name, {
                    value: '0',
                    libelle: '',
                    messageType: '',
                    message: ''
                });
            }
        }

        //console.log("6 watchParams➜",this.name,this.ngModel);

        // 🟦 Met à jour les options filtrées
        //console.log("7 watchParams➜ filterOptions ➜ [watchGroup]",this.name);
        this.filterOptions(true, false, () => this.checkNgModel());
    }

    //--------------------------------------------------------------
    // CHARGEMENT SELON LE DATATYPE
    //--------------------------------------------------------------
    async loadDataAccordingToDatatype(datalinkValues) {
        // console.log("-----------------------------------------------");
        // console.log("loadDataAccordingToDatatype", this.config.datatype);
        // console.log("values:", datalinkValues);
        // console.log("-----------------------------------------------");

        switch (this.config.datatype) {
            // ------------------------------------------------------
            // SOCIÉTÉ
            // ------------------------------------------------------
            case 'societe':
                await this.loadSociete();
                break;

            // ------------------------------------------------------
            // SITE
            // ------------------------------------------------------
            case 'site':
                await this.loadSite(datalinkValues);
                break;

            case 'sites':
                await this.loadSites(datalinkValues);
                break;

            // ------------------------------------------------------
            // Bennes
            // ------------------------------------------------------
            case 'benne':
                await this.loadBennes(datalinkValues);
                break;

            // ------------------------------------------------------
            // Véhicule
            // ------------------------------------------------------
            case 'vehicule':
                await this.loadVehicules(datalinkValues);
                break;

            // ------------------------------------------------------
            // Transporteur
            // ------------------------------------------------------
            case 'transporteur':
                await this.loadTransporteurs(datalinkValues);
                break;

            // ------------------------------------------------------
            // Chauffeur
            // ------------------------------------------------------
            case 'chauffeur':
                await this.loadChauffeurs(datalinkValues);
                break;

            // ------------------------------------------------------
            // Fournisseur
            // ------------------------------------------------------
            case 'fournisseur':
                await this.loadFournisseurs(datalinkValues);
                break;

            // ------------------------------------------------------
            // Provenance
            // ------------------------------------------------------
            case 'provenance':
                await this.loadProvenances(datalinkValues);
                break;

            // ------------------------------------------------------
            // Destination
            // ------------------------------------------------------
            case 'destination':
                await this.loadDestinations(datalinkValues);
                break;

            // ------------------------------------------------------
            // Commande
            // ------------------------------------------------------
            case 'commande':
                await this.loadCommandes(datalinkValues);
                break;

            // ------------------------------------------------------
            // Produit
            // ------------------------------------------------------
            case 'produit':
                await this.loadProduits(datalinkValues);
                break;

            // ------------------------------------------------------
            // Client
            // ------------------------------------------------------
            case 'client':
                await this.loadClients(datalinkValues);
                break;

            case 'clientFournisseur':
                await this.loadClientsFournisseurs(datalinkValues);
                break;

            default:
                console.warn('Datatype inconnu :', this.config.datatype);
                break;
        }
    }

    //--------------------------------------------------------------
    // TRANSFORMATIONS DE DONNÉES (inchangées)
    //--------------------------------------------------------------
    transformData(input) {
        if (input) {
            return input.map((item) => ({
                id: item.id,
                value: (item.code ? item.code : '') + (item.libelle ? ' | ' + item.libelle : '')
            }));
        } else {
            return [];
        }
    }

    transformDataBenneTracteur(input) {
        return input.map((item) => ({
            id: item.id,
            value: item.im
        }));
    }

    transformDataVehicule(input) {
        return input
            .filter((item) => item.a !== null || item.b !== null)
            .map((item) => ({
                id: item.id,
                value: item.a + (item.b != null ? ' - ' + item.b : '')
            }));
    }

    transformDataChauffeur(input) {
        return input
            .filter((item) => item.nom !== null || item.prenom !== null)
            .map((item) => ({
                id: item.id,
                value: item.code + ' | ' + item.nom + ' ' + item.prenom
            }));
    }

    transformDataProduit(input) {
        return input.map((item) => ({
            id: item.id + '_' + item.producteurId,
            value: item.code + ' | ' + item.libelle + ' [' + item.producteurLibelleBis + ']'
        }));
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : SOCIETE
    //--------------------------------------------------------------
    async loadSociete(paramValues) {
        console.log('🔥 - MassiaSelectController - loadSociete - paramValues:', paramValues);
        // Aucun param obligatoire, mais la méthode garde la signature standard
        // Exemple: this.config.params = [] pour societe

        this.startLoadingData();

        const ret = await this.MassiaSelectService.getSocietesCom();

        this.endLoadingData();

        this.options = this.transformData(ret);

        this.placeholder = this.options.length ? 'Sélection de la société' : 'Aucune donnée';
        this.checkValuePostProcess();
        await this.checkCallbackListReceived('Sélection de la société');
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : SITE (paramValues = idSociete)
    //--------------------------------------------------------------
    async loadSite(params) {
        if (!this.checkParamsAreValid(params)) return;

        const societe = params?.societe ?? null;

        this.startLoadingData();
        this.loadingId = params;

        const ret = await this.MassiaSelectService.getSitesCom(societe);

        if (params === this.loadingId) {
            this.endLoadingData();
            this.options = this.transformData(ret);
            this.placeholder = this.options.length ? 'Sélection du site commercial' : 'Aucune donnée';
            this.checkValuePostProcess();
            await this.checkCallbackListReceived('Sélection du site commercial');
        }
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : SITES
    //--------------------------------------------------------------
    async loadSites(params) {
        if (!this.checkParamsAreValid(params)) return;

        // const site = params?.societe ?? null;

        this.startLoadingData();
        this.loadingId = params;

        const ret = await this.MassiaSelectService.getSites(params.societe);

        if (params === this.loadingId) {
            this.endLoadingData();
            this.options = this.transformData(ret);
            this.placeholder = this.options.length ? 'Sélection du site' : 'Aucune donnée';
            this.checkValuePostProcess();
            await this.checkCallbackListReceived('Sélection du site');
        }
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : CLIENTS
    //--------------------------------------------------------------
    async loadClients(params) {
        if (!this.checkParamsAreValid(params)) return;

        const societe = params?.societe ?? null;

        this.startLoadingData();
        this.loadingId = params;

        const ret = await this.MassiaSelectService.getClients(societe);

        if (params === this.loadingId) {
            this.endLoadingData();
            this.options = this.transformData(ret);
            this.placeholder = this.options.length ? 'Sélection du client' : 'Aucune donnée';
            this.checkValuePostProcess();
            await this.checkCallbackListReceived('Sélection du client');
        }
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : CLIENTS
    //--------------------------------------------------------------
    async loadClientsFournisseurs(params) {
        if (!this.checkParamsAreValid(params)) return;

        const societe = params?.societe ?? null;

        this.startLoadingData();
        this.loadingId = params;

        const ret = await this.MassiaSelectService.getClientsFournisseurs(societe);

        if (params === this.loadingId) {
            this.endLoadingData();
            this.options = this.transformData(ret);
            this.placeholder = this.options.length ? 'Sélection du client / fournisseur' : 'Aucune donnée';
            this.checkValuePostProcess();
            await this.checkCallbackListReceived('Sélection du client / fournisseur');
        }
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : TRACTEURS
    //--------------------------------------------------------------
    async loadTracteurs() {
        this.startLoadingData();
        const ret = await this.MassiaSelectService.getTracteurs();
        this.endLoadingData();

        this.options = this.transformDataBenneTracteur(ret);
        this.placeholder = this.options.length ? 'Sélection du tracteur' : 'Aucune donnée';
        this.checkValuePostProcess();
        await this.checkCallbackListReceived('Sélection du tracteur');
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : BENNES
    //--------------------------------------------------------------
    async loadBennes(params) {
        if (!this.checkParamsAreValid(params)) return;

        const benne = params?.benne ?? null;

        this.startLoadingData();
        this.loadingId = params;

        const ret = await this.MassiaSelectService.getBennes(benne);

        if (params === this.loadingId) {
            this.endLoadingData();
            this.options = this.transformDataBenneTracteur(ret);
            this.placeholder = this.options.length ? 'Sélection de la benne' : 'Aucune donnée';
            this.checkValuePostProcess();
            await this.checkCallbackListReceived('Sélection de la benne');
        }
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : VÉHICULES
    //--------------------------------------------------------------
    async loadVehicules(params) {
        if (!this.checkParamsAreValid(params)) return;

        const vehicule = params?.vehicule ?? null;

        this.startLoadingData();
        this.loadingId = params;

        const ret = await this.MassiaSelectService.getVehicules(vehicule);

        if (params === this.loadingId) {
            this.endLoadingData();
            this.options = this.transformDataVehicule(ret);
            this.placeholder = this.options.length ? 'Sélection du véhicule' : 'Aucune donnée';
            this.checkValuePostProcess();
            await this.checkCallbackListReceived('Sélection du véhicule');
        }
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : TRANSPORTEURS
    //--------------------------------------------------------------
    async loadTransporteurs(params) {
        if (!this.checkParamsAreValid(params)) return;

        var ret = null;
        const societe = params?.societe ?? null;
        const site = params?.site ?? null;

        this.startLoadingData();
        this.loadingId = params;

        if (site != null) {
            ret = await this.MassiaSelectService.getTransporteurs(site);
        } else {
            ret = await this.MassiaSelectService.getSitesTransporteur(societe);
        }

        if (params === this.loadingId) {
            this.endLoadingData();
            this.options = this.transformData(ret);
            this.placeholder = this.options.length ? 'Sélection du transporteur' : 'Aucune donnée';
            this.checkValuePostProcess();
            await this.checkCallbackListReceived('Sélection du transporteur');
        }
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : CHAUFFEURS
    //--------------------------------------------------------------
    async loadChauffeurs(params) {
        if (!this.checkParamsAreValid(params)) return;

        const transporteur = params?.transporteur ?? null;

        this.startLoadingData();
        this.loadingId = params;

        const ret = await this.MassiaSelectService.getChauffeurs(transporteur);

        if (params === this.loadingId) {
            this.endLoadingData();
            this.options = this.transformDataChauffeur(ret);
            this.placeholder = this.options.length ? 'Sélection du chauffeur' : 'Aucune donnée';
            this.checkValuePostProcess();
            await this.checkCallbackListReceived('Sélection du chauffeur');
        }
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : FOURNISSEURS
    //--------------------------------------------------------------
    async loadFournisseurs(params) {
        if (!this.checkParamsAreValid(params)) return;

        const site = params?.site ?? null;

        this.startLoadingData();
        this.loadingId = params;

        const ret = await this.MassiaSelectService.getFournisseurs(site);

        if (params === this.loadingId) {
            this.endLoadingData();
            this.options = this.transformData(ret);
            this.placeholder = this.options.length ? 'Sélection du fournisseur' : 'Aucune donnée';
            this.checkValuePostProcess();
            await this.checkCallbackListReceived('Sélection du fournisseur');
        }
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : PROVENANCES / CHANTIER
    //--------------------------------------------------------------
    async loadChantiers(params, placeholder = 'Sélection du chantier') {
        if (!this.checkParamsAreValid(params)) return;

        var client = params?.client ?? null;
        const fournisseur = params?.fournisseur ?? null;
        const dateActif = params?.dateActif ?? null;

        if (fournisseur != null) {
            client = fournisseur;
        }

        this.startLoadingData();
        this.loadingId = params;

        const ret = await this.MassiaSelectService.getProvenances(client, dateActif);

        if (params === this.loadingId) {
            this.endLoadingData();
            this.options = this.transformData(ret);
            this.placeholder = this.options.length ? placeholder : 'Aucune donnée';
            this.checkValuePostProcess();
            await this.checkCallbackListReceived(placeholder);
        }
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : PROVENANCES / CHANTIER
    //--------------------------------------------------------------
    async loadProvenances(params) {
        return await this.loadChantiers(params, 'Sélection de la provenance');
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : DESTINATION (multiple params)
    //--------------------------------------------------------------

    async loadDestinations(params) {
        // console.log("--------------------------------------------------------------");
        // console.log("------------- LOAD DESTINATIONS ------------------------------");
        // console.log(params);

        // Extraction propre
        const provenance = params?.provenance ?? null;
        const societe = params?.societe ?? null;

        if (!this.checkParamsAreValid(params)) return;

        this.startLoadingData();
        this.loadingId = JSON.stringify(params);

        let ret = [];

        // Appel API uniquement si les deux valeurs sont renseignées
        if (provenance !== null || societe !== null) {
            ret = await this.MassiaSelectService.getDestinationByChantierOrSociete(provenance, societe);
        }

        // Sécurisation : éviter les collisions async
        if (JSON.stringify(params) === this.loadingId) {
            this.endLoadingData();
            this.options = this.transformData(ret);

            this.placeholder = this.options.length ? 'Sélection de la destination' : 'Aucune donnée';

            this.checkValuePostProcess();
            await this.checkCallbackListReceived('Sélection de la destination');
        }
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : COMMANDES
    //--------------------------------------------------------------
    async loadCommandes(params) {
        if (!this.checkParamsAreValid(params)) return;

        const provenance = params?.provenance ?? null;
        const societe = params?.societe ?? null;

        this.startLoadingData();
        this.loadingId = params;

        const ret = await this.MassiaSelectService.getCommandes(provenance, societe);

        if (params === this.loadingId) {
            this.endLoadingData();
            this.options = this.transformData(ret);
            this.placeholder = this.options.length ? 'Sélection de la commande' : 'Aucune donnée';
            this.checkValuePostProcess();
            await this.checkCallbackListReceived('Sélection de la commande');
        }
    }

    //--------------------------------------------------------------
    // 🟩 LOAD : PRODUITS
    //--------------------------------------------------------------
    async loadProduits(params) {
        console.log('🔥 - MassiaSelectController - loadProduits - params:', params);
        if (!this.checkParamsAreValid(params)) return;

        const site = params?.site ?? null;
        const sens = params?.sens ?? 2; // correspond à la fois aux produits entrants et sortants
        const client = params?.client ?? null;
        console.log('🔥 - MassiaSelectController - loadProduits - client:', client, sens, site);

        this.startLoadingData();
        this.loadingId = params;

        // console.log(">>>>>>>>>>>>>>>>>>>>>>>",sens,params);

        const ret = await this.MassiaSelectService.getProduits(site, sens, client);

        if (params === this.loadingId) {
            this.endLoadingData();
            this.options = this.transformDataProduit(ret);
            this.placeholder = this.options.length ? 'Sélection du produit' : 'Aucune donnée';
            this.checkValuePostProcess();
            await this.checkCallbackListReceived('Sélection du produit');
        }
    }

    async checkCallbackListReceived(defaultText = 'Sélection') {
        if (this.options.length > 0 && this.callbackListReceived) {
            var newListe = await this.callbackListReceived({ liste: this.options });
            if (newListe) {
                this.placeholder = newListe.length && newListe.some((l) => !l.hide) ? defaultText : 'Aucune donnée pour les filtres appliqués';
                this.options = newListe;
            }
        }
    }

    clearInput() {
        this.searchText = '';
        //console.log("filterOptions ➜ [clearInput]", this.name);
        this.filterOptions();
        this.isFocused = true;
    }

    //--------------------------------------------------------------
    // FILTRAGE DES OPTIONS
    //--------------------------------------------------------------
    filterOptions(resetDisplayLimit = true, resetNgModel = true, callbackAction = null) {
        if (resetDisplayLimit) this.displayLimit = 20;
        // console.log("-------------------------------------------------------------------------------------------------------------------------------------------");
        // console.log("filterOptions "+ this.name);
        // console.log("-------------------------------------------------------------------------------------------------------------------------------------------");
        // Réinitialise la valeur si demandé
        //console.log("filterOptions ➜", this.name);

        if (resetNgModel) {
            // Avant de réinitialiser, vérifier si le texte correspond exactement à une option (avec trim)
            if (this.searchText) {
                const searchTrimmed = this.searchText.trim().toLowerCase();
                const exactMatch = this.options.find((option) => option.value.trim().toLowerCase() === searchTrimmed);
                if (exactMatch) {
                    this.ngModel = String(exactMatch.id);
                } else {
                    this.ngModel = '0';
                }
            } else {
                this.ngModel = '0';
            }
            //console.log("filterOptions ➜ resetNgModel ➜",this.name);
        }

        // Recherche de l'option correspondant au ngModel
        let selectedOption = null;

        //console.log("filterOptions ➜",this.name,this.ngModel);

        if (this.ngModel && this.ngModel !== '0') {
            selectedOption = this.options.find((o) => String(o.id) === String(this.ngModel));
        }

        //console.log("filterOptions ➜ selectedOption ➜",this.name,this.ngModel);
        // Si l'option n'existe plus → réinitialise la valeur
        if (!selectedOption && !this.searchText) {
            this.ngModel = '0';
        }

        // Prépare la valeur pour SharedData
        const dataObject = {
            value: String(this.ngModel),
            libelle: selectedOption ? selectedOption.value : '',
            messageType: '',
            message: ''
        };

        if (this.config.callbackOnChange != null) this.config.callbackOnChange(this.ngModel);
        this.SharedDataService.setData(this.name, dataObject);

        // Initialisez options et searchText si elles sont nulles ou indéfinies
        this.options = this.options || [];
        this.searchText = this.searchText || '';

        // Temporisation de 300ms
        this.$timeout(() => {
            if (this.searchText.length > 0) {
                const searchTrimmed = this.searchText.trim().toLowerCase();
                this.filteredOptions = this.options
                    .filter((option) => !option.hide && option.value.trim().toLowerCase().includes(searchTrimmed))
                    .slice(0, this.displayLimit);

                // Si le texte de recherche correspond exactement à une option (avec trim), on la sélectionne
                const exactMatch = this.options.find((option) => option.value.trim().toLowerCase() === searchTrimmed);
                if (exactMatch && this.ngModel === '0') {
                    this.ngModel = String(exactMatch.id);
                    this.SharedDataService.setData(this.name, {
                        value: String(exactMatch.id),
                        libelle: exactMatch.value,
                        messageType: '',
                        message: ''
                    });
                }
            } else {
                this.filteredOptions = this.options.filter((option) => !option.hide).slice(0, this.displayLimit);
            }
            if (callbackAction != null) {
                callbackAction();
            }
        }, 300);
    }

    //--------------------------------------------------------------
    // CHARGEMENT DE PLUS D'OPTIONS
    //--------------------------------------------------------------
    loadMoreOptions() {
        this.displayLimit += 100;

        // console.log("loadMoreOptions filterOptions false");
        //console.log("filterOptions ➜ [loadMoreOptions]", this.name);
        this.filterOptions(false);

        if (this.unfocusTimeout) {
            clearTimeout(this.unfocusTimeout);
            this.unfocusTimeout = null;
        }

        // On garde la fenêtre ouverte
        const elemName = 'list_' + this.name + '_input';
        const input = document.getElementById(elemName);

        if (input) {
            input.focus({ preventScroll: true });
            this.isFocused = true;
        }
    }

    //--------------------------------------------------------------
    // VALIDATION UI VIA SHARED DATA SERVICE
    //--------------------------------------------------------------
    verifyForm(newValueObject /* , oldValueObject */) {
        //console.log("--------------------------------------------------------------------------------------------------------------verifyForm (1)");
        //console.log(this.name);
        //console.log(oldValueObject + " ===> " , newValueObject );

        // Active le mode erreur si le message reçu signale une anomalie
        this.error = false;
        if (newValueObject.messageType === 'error') {
            this.error = true;
            this.messageError = newValueObject.message;
        }

        // Traite une mise à jour imposée depuis le retour ResultForm (SharedDataService).
        // Lorsque messageType = 'change', le composant doit appliquer la nouvelle valeur
        // en recherchant l’option correspondante puis en la sélectionnant comme si
        // l’utilisateur l’avait choisie manuellement.
        if (newValueObject.messageType === 'change') {
            const newValue = String(newValueObject.value);

            // 🟢 1) Cherche l’option correspondante dans les options actuelles
            const opt = this.options.find((o) => String(o.id) === newValue);

            if (opt) {
                // 🟢 2) Sélectionne proprement l’élément
                this.selectOption(opt);
            } else {
                // 🔴 Option non trouvée → reset propre
                this.ngModel = '0';
                this.searchText = '';
                this.SharedDataService.setData(this.name, {
                    value: '0',
                    libelle: '',
                    messageType: '',
                    message: ''
                });
            }

            return;
        }

        if (this.ngModel != '' && (newValueObject.value == '' || newValueObject.value == '0')) {
            this.ngModel = 0;
        }
    }

    //--------------------------------------------------------------
    // SCROLL AUTOMATIQUE VERS L'OPTION SELECTIONNÉE
    //--------------------------------------------------------------
    async scrollToHighlighted() {
        var container = document.querySelector('#list_' + this.name);
        if (!container) return;

        var highlighted = container.querySelector('li.selected');
        if (!highlighted) return;

        highlighted.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
        });
    }

    //--------------------------------------------------------------
    // NAVIGATION CLAVIER
    //--------------------------------------------------------------
    handleKeyDown(event) {
        switch (event.keyCode) {
            // 🔽 Fleche bas
            case 40:
                if (this.highlightedIndex < this.filteredOptions.length - 1) {
                    this.highlightedIndex++;
                    this.$timeout(() => this.scrollToHighlighted(), 0);
                }
                break;

            // 🔼 Fleche haut
            case 38:
                if (this.highlightedIndex > 0) {
                    this.highlightedIndex--;
                    this.$timeout(() => this.scrollToHighlighted(), 0);
                }
                break;

            // ⏎ Enter
            // ↹ Tab
            case 13:
            case 9:
                event.preventDefault();
                if (this.highlightedIndex >= 0 && this.highlightedIndex < this.filteredOptions.length) {
                    this.selectOption(this.filteredOptions[this.highlightedIndex]);
                }
                this.highlightedIndex = -1;
                this.focusNextField();
                break;
        }
    }

    //--------------------------------------------------------------
    // FOCUS SUR LE CHAMP SUIVANT
    //--------------------------------------------------------------
    focusNextField() {
        const fields = document.querySelectorAll('input, select, textarea, button, [tabindex]');
        const active = document.activeElement;
        let next = null;

        for (let i = 0; i < fields.length; i++) {
            if (fields[i] === active) {
                for (let j = i + 1; j < fields.length; j++) {
                    if (!fields[j].disabled && fields[j].offsetParent !== null) {
                        next = fields[j];
                        break;
                    }
                }
                break;
            }
        }

        if (next) next.focus();
    }

    //--------------------------------------------------------------
    // SELECTION D'UNE OPTION
    //--------------------------------------------------------------
    selectOption(option, fromFirstValue = false) {
        // console.log('🔥 - MassiaSelectController - selectOption - option:', option, this);

        // Déclenche l'event externe si fourni
        if (this.onSelect) {
            this.onSelect({ selected: option });
        }

        // Met à jour le modèle
        this.ngModel = String(option.id);
        this.searchText = option.value;
        // console.log('🔥 - MassiaSelectController - selectOption - this.searchText:', this.searchText);
        this.isFocused = false;

        // Met à jour SharedDataService
        const dataObject = {
            value: String(this.ngModel), // Identifiant choisi
            libelle: option.value, // Libellé affiché
            messageType: '',
            message: ''
        };
        if (!fromFirstValue && this.config.callbackOnSelect != null) this.config.callbackOnSelect(this.ngModel);
        this.SharedDataService.setData(this.name, dataObject);
        if (this.config.localStorageKey) {
            this.localStorageService.set(this.config.localStorageKey, dataObject);
        }
    }

    //--------------------------------------------------------------
    // CHECK NG-MODEL EXISTANT (initialisation)
    //--------------------------------------------------------------
    checkNgModel() {
        // Vérifie si le ngModel correspond à une option chargée
        const exists = this.options.some((o) => o.id == this.ngModel);
        if (!exists) {
            // Vide le champ si la valeur n'est plus valide
            this.ngModel = '0';
            this.searchText = '';

            // Met à jour la donnée partagée
            this.SharedDataService.setData(this.name, {
                value: '0',
                libelle: '',
                messageType: '',
                message: ''
            });
        }
    }

    ///--------------------------------------------------------------
    // GET ONE BY TYPE AND ID (pour récupérer la valeur initiale sans attendre les datalinks)
    //--------------------------------------------------------------
    async getOneByTypeAndId() {
        if (!this.initialValue) return null;

        if (this.config.datatype == 'produit' && this.initialValue && this.initialValue.includes('_')) {
            let idProduit = this.initialValue.split('_')[0];
            let idProducteur = this.initialValue.split('_')[1];
            let ret = await this.MassiaSelectService.getOneByTypeAndId('produit', idProduit);
            let producteur = await this.MassiaSelectService.getOneByTypeAndId('site', idProducteur);
            if (ret && producteur) {
                ret.id += '_' + idProducteur;
                ret.producteurLibelleBis = producteur.libelle;
            }
            return ret;
        }
        return await this.MassiaSelectService.getOneByTypeAndId(this.config.datatype, this.initialValue);
    }

    //--------------------------------------------------------------
    // CHECK VAL INITIALE (cas popup rechargé)
    //--------------------------------------------------------------
    async checkFirstValue() {
        try {
            if ((this.initialValue && this.initialValue > 0) || (this.initialValue.includes && this.initialValue.includes('_'))) {
                var res = await this.getOneByTypeAndId();
                if (res && res.id) {
                    const opt = this.transformData([res])[0];
                    this.initialOption = opt;
                    this.options = [opt, ...this.options];
                    this.selectOption(opt, true);
                }
            }
        } catch (error) {
            console.warn('[MassiaSelect] checkFirstValue error (getOneByTypeAndId non disponible ?) :', error);
        } finally {
            //On prévient le superviseur qu'on est prêt
            this.initComplete = true;
            this._resolveReady();
        }
    }

    async checkValuePostProcess() {
        //On remet l'option initiale si elle n'est pas dans la liste des options chargées mais que pour le premier chargement
        if (this.initialOption && !this.options.some((o) => o.id == this.initialOption.id)) {
            if (this.ngModel == this.initialOption.id) {
                this.options = [this.initialOption, ...this.options];
            }
            this.initialOption = null;
        }

        if (this.config.autoSelectOnlyOne && this.options.length === 1) {
            this.selectOption(this.options[0], true);
        } else if (this.config.localStorageKey && !this.localStorageLoaded) {
            const localData = this.localStorageService.get(this.config.localStorageKey);
            if (localData) {
                const opt = this.options.find((o) => o.id == localData.value);
                if (opt) {
                    this.selectOption(opt, true);
                }
            }
            this.localStorageLoaded = true;
        }
        //Reset des options pour éviter un selectOption sur une option qui n'existerait plus après un reload
        this.filteredOptions = [];
    }

    //--------------------------------------------------------------
    // RESET TOTAL
    //--------------------------------------------------------------
    reset() {
        this.ngModel = '0';
        this.searchText = '';
        this.options = [];
    }

    //--------------------------------------------------------------
    // FOCUS / BLUR
    //--------------------------------------------------------------
    onFocus() {
        this.isFocused = true;
        this.filterOptions(true, false);
    }

    onBlur(event) {
        // Si le blur vient d'un clic sur la liste → ne rien faire
        const related = event.relatedTarget;
        const list = document.getElementById('list_' + this.name);

        if (list && list.contains(related)) {
            return;
        }

        // Si pas de related target => on ferme après un court délai
        this.unfocusTimeout = setTimeout(() => {
            // Tenter de sélectionner automatiquement si le texte correspond exactement à une option (avec trim)
            if (this.searchText && this.ngModel === '0') {
                const searchTrimmed = this.searchText.trim().toLowerCase();
                const exactMatch = this.options.find((option) => option.value.trim().toLowerCase() === searchTrimmed);
                if (exactMatch) {
                    this.selectOption(exactMatch);
                }
            }

            this.isFocused = false;
            this.$scope.$apply();
            this.unfocusTimeout = null;
        }, 150);
    }

    //--------------------------------------------------------------
    // INITIALISATION
    //--------------------------------------------------------------
    async $onInit() {
        // -----------------------------------------------------------
        // 0) Préparation pour le Supervisor
        // -----------------------------------------------------------
        this.readyPromise = new Promise((resolve) => (this._resolveReady = resolve));
        this.MassiaSelectSupervisorService.addController(this);

        try {
            await this.waitUntilDefined(() => this.config);

            // -----------------------------------------------------------
            // 1) Analyse du nouveau format PARAMS
            // -----------------------------------------------------------
            this.parseParams();

            // Initialise SharedDataService pour chaque param si pas présent
            this.paramKeys.forEach((key) => {
                if (key.datalink && !this.SharedDataService.getData(key.datalink)) {
                    this.SharedDataService.setData(key.datalink, {
                        value: '',
                        libelle: '',
                        messageType: '',
                        message: ''
                    });
                }
            });

            // -----------------------------------------------------------
            // 2) Initialise SharedData pour CE select
            // -----------------------------------------------------------
            const dataObject = {
                value: String(this.ngModel ?? ''),
                libelle: '',
                messageType: '',
                message: ''
            };
            this.SharedDataService.setData(this.name, dataObject);

            // -----------------------------------------------------------
            // 3) Mise en place du watcher paramétrique (nouveau système)
            // -----------------------------------------------------------
            //this.watchParams(); Deprecated

            // -----------------------------------------------------------
            // 4) Attendre que ngModel soit défini avant de charger
            // -----------------------------------------------------------

            // Sélection initiale si valeur déjà présente
            if (this.ngModel) {
                this.initialValue = this.ngModel;
                this.checkFirstValue();
            } else {
                //Au cas où le ngModel soit init quelques frames après
                const unwatch = this.$scope.$watch(
                    () => this.ngModel,
                    (newVal) => {
                        if (newVal != undefined) {
                            this.initialValue = newVal;
                            this.checkFirstValue();
                            unwatch();
                        }
                    }
                );
            }
        } catch (error) {
            console.error('🚀 ~ MassiaSelectController ~ $onInit ~ error:', error);
            this.initComplete = true;
            this._resolveReady();
        }
    }

    ///--------------------------------------------------------------
    // PREMIER CHARGEMENT (Appelé par le superviseur une fois que tous les controllers sont prêts)
    //--------------------------------------------------------------
    async firstLoad() {
        if (this.firstLoadComplete) return;
        const paramValues = this.getParamValues();
        await this.loadDataAccordingToDatatype(paramValues);
        this.firstLoadComplete = true;
    }

    //--------------------------------------------------------------
    // API - Configuration par les .config dans les controller parents
    //--------------------------------------------------------------
    $onChanges(changes) {
        if (this.api) {
            this.api.reload = () => this.checkParamsAndLoad();
        }
        if (changes.disabled) {
            if (changes.disabled.currentValue) {
                this.searchText = '';
            } else if (!changes.disabled.isFirstChange()) {
                this.checkParamsAndLoad();
            }
        }
    }

    //--------------------------------------------------------------
    // ATTENDRE VARIABLES (évite async/cycle Angular)
    //--------------------------------------------------------------
    waitForVariables(callback) {
        if (typeof this.ngModel === 'undefined') {
            this.ngTimeout = setTimeout(() => {
                this.waitForVariables(callback);
            }, 50);
        } else {
            if (callback) callback();
        }
    }

    //--------------------------------------------------------------
    // LOADING UTILS
    //--------------------------------------------------------------
    startLoadingData() {
        this.loadingData = true;
        this.placeholder = 'Chargement en cours...';
    }

    endLoadingData() {
        this.loadingData = false;
    }

    //--------------------------------------------------------------
    // DESTRUCTION
    //--------------------------------------------------------------
    $onDestroy() {
        this.MassiaSelectSupervisorService.removeController(this);
    }

    getTooltip() {
        if (this.loadingData) return 'FORM.LOADING';
        if (this.supervisorError) return 'FORM.SUPERVISOR_ERROR';
        if (this.supervisorWaiting) return 'FORM.SUPERVISOR_NOT_READY';
        return '';
    }
}
